/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfListOfGetPublicReceiveKeywordsListDto } from '../models/custom-result-of-list-of-get-public-receive-keywords-list-dto';
import { CustomResultOfListOfGetUsedOrganizationsForPublicNumbersListDto } from '../models/custom-result-of-list-of-get-used-organizations-for-public-numbers-list-dto';
import { CustomResultOfPaginatedListOfGetUsedPublicNumbersWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-used-public-numbers-with-pagination-dto';
import { CustomResultOfPaginatedListOfPrivateReceiveKeywordsWithPaginationDto } from '../models/custom-result-of-paginated-list-of-private-receive-keywords-with-pagination-dto';
import { CustomResultOfPaginatedListOfPublicReceiveKeywordsWithPaginationDto } from '../models/custom-result-of-paginated-list-of-public-receive-keywords-with-pagination-dto';
import { CustomResultOfReceiveKeywordDto } from '../models/custom-result-of-receive-keyword-dto';
import { receiveKeywordsCreatePrivateReceiveKeywordGet } from '../fn/receive-keywords/receive-keywords-create-private-receive-keyword-get';
import { ReceiveKeywordsCreatePrivateReceiveKeywordGet$Params } from '../fn/receive-keywords/receive-keywords-create-private-receive-keyword-get';
import { receiveKeywordsCreatePrivateReceiveKeywordPost } from '../fn/receive-keywords/receive-keywords-create-private-receive-keyword-post';
import { ReceiveKeywordsCreatePrivateReceiveKeywordPost$Params } from '../fn/receive-keywords/receive-keywords-create-private-receive-keyword-post';
import { receiveKeywordsCreatePublicReceiveKeywordGet } from '../fn/receive-keywords/receive-keywords-create-public-receive-keyword-get';
import { ReceiveKeywordsCreatePublicReceiveKeywordGet$Params } from '../fn/receive-keywords/receive-keywords-create-public-receive-keyword-get';
import { receiveKeywordsCreatePublicReceiveKeywordPost } from '../fn/receive-keywords/receive-keywords-create-public-receive-keyword-post';
import { ReceiveKeywordsCreatePublicReceiveKeywordPost$Params } from '../fn/receive-keywords/receive-keywords-create-public-receive-keyword-post';
import { receiveKeywordsDelete } from '../fn/receive-keywords/receive-keywords-delete';
import { ReceiveKeywordsDelete$Params } from '../fn/receive-keywords/receive-keywords-delete';
import { receiveKeywordsGetPrivateReceiveKeywordsWithPagination } from '../fn/receive-keywords/receive-keywords-get-private-receive-keywords-with-pagination';
import { ReceiveKeywordsGetPrivateReceiveKeywordsWithPagination$Params } from '../fn/receive-keywords/receive-keywords-get-private-receive-keywords-with-pagination';
import { receiveKeywordsGetPublicReceiveKeywordsList } from '../fn/receive-keywords/receive-keywords-get-public-receive-keywords-list';
import { ReceiveKeywordsGetPublicReceiveKeywordsList$Params } from '../fn/receive-keywords/receive-keywords-get-public-receive-keywords-list';
import { receiveKeywordsGetPublicReceiveKeywordsWithPagination } from '../fn/receive-keywords/receive-keywords-get-public-receive-keywords-with-pagination';
import { ReceiveKeywordsGetPublicReceiveKeywordsWithPagination$Params } from '../fn/receive-keywords/receive-keywords-get-public-receive-keywords-with-pagination';
import { receiveKeywordsGetReceiveKeywordById } from '../fn/receive-keywords/receive-keywords-get-receive-keyword-by-id';
import { ReceiveKeywordsGetReceiveKeywordById$Params } from '../fn/receive-keywords/receive-keywords-get-receive-keyword-by-id';
import { receiveKeywordsGetReceiveKeywordsAudit } from '../fn/receive-keywords/receive-keywords-get-receive-keywords-audit';
import { ReceiveKeywordsGetReceiveKeywordsAudit$Params } from '../fn/receive-keywords/receive-keywords-get-receive-keywords-audit';
import { receiveKeywordsGetUsedPublicNumbersWithPagination } from '../fn/receive-keywords/receive-keywords-get-used-public-numbers-with-pagination';
import { ReceiveKeywordsGetUsedPublicNumbersWithPagination$Params } from '../fn/receive-keywords/receive-keywords-get-used-public-numbers-with-pagination';
import { receiveKeywordsUpdatePrivateReceiveKeywordGet } from '../fn/receive-keywords/receive-keywords-update-private-receive-keyword-get';
import { ReceiveKeywordsUpdatePrivateReceiveKeywordGet$Params } from '../fn/receive-keywords/receive-keywords-update-private-receive-keyword-get';
import { receiveKeywordsUpdatePrivateReceiveKeywordPut } from '../fn/receive-keywords/receive-keywords-update-private-receive-keyword-put';
import { ReceiveKeywordsUpdatePrivateReceiveKeywordPut$Params } from '../fn/receive-keywords/receive-keywords-update-private-receive-keyword-put';
import { receiveKeywordsUpdatePublicReceiveKeywordsGet } from '../fn/receive-keywords/receive-keywords-update-public-receive-keywords-get';
import { ReceiveKeywordsUpdatePublicReceiveKeywordsGet$Params } from '../fn/receive-keywords/receive-keywords-update-public-receive-keywords-get';
import { receiveKeywordsUpdatePublicReceiveKeywordsPut } from '../fn/receive-keywords/receive-keywords-update-public-receive-keywords-put';
import { ReceiveKeywordsUpdatePublicReceiveKeywordsPut$Params } from '../fn/receive-keywords/receive-keywords-update-public-receive-keywords-put';

@Injectable({ providedIn: 'root' })
export class ReceiveKeywordsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `receiveKeywordsGetReceiveKeywordsAudit()` */
  static readonly ReceiveKeywordsGetReceiveKeywordsAuditPath = '/ReceiveKeywords/GetReceiveKeywordsAudit';

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiveKeywordsGetReceiveKeywordsAudit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiveKeywordsGetReceiveKeywordsAudit$Response(params: ReceiveKeywordsGetReceiveKeywordsAudit$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return receiveKeywordsGetReceiveKeywordsAudit(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiveKeywordsGetReceiveKeywordsAudit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiveKeywordsGetReceiveKeywordsAudit(params: ReceiveKeywordsGetReceiveKeywordsAudit$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.receiveKeywordsGetReceiveKeywordsAudit$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `receiveKeywordsGetPrivateReceiveKeywordsWithPagination()` */
  static readonly ReceiveKeywordsGetPrivateReceiveKeywordsWithPaginationPath = '/ReceiveKeywords/GetPrivateReceiveKeywordsWithPagination';

  /**
   * For each user get Private ReceiveKeywords with paging.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiveKeywordsGetPrivateReceiveKeywordsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiveKeywordsGetPrivateReceiveKeywordsWithPagination$Response(params: ReceiveKeywordsGetPrivateReceiveKeywordsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfPrivateReceiveKeywordsWithPaginationDto>> {
    return receiveKeywordsGetPrivateReceiveKeywordsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * For each user get Private ReceiveKeywords with paging.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiveKeywordsGetPrivateReceiveKeywordsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiveKeywordsGetPrivateReceiveKeywordsWithPagination(params: ReceiveKeywordsGetPrivateReceiveKeywordsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfPrivateReceiveKeywordsWithPaginationDto> {
    return this.receiveKeywordsGetPrivateReceiveKeywordsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfPrivateReceiveKeywordsWithPaginationDto>): CustomResultOfPaginatedListOfPrivateReceiveKeywordsWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `receiveKeywordsGetPublicReceiveKeywordsWithPagination()` */
  static readonly ReceiveKeywordsGetPublicReceiveKeywordsWithPaginationPath = '/ReceiveKeywords/GetPublicReceiveKeywordsWithPagination';

  /**
   * For each user get Public ReceiveKeywords with paging.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiveKeywordsGetPublicReceiveKeywordsWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiveKeywordsGetPublicReceiveKeywordsWithPagination$Response(params: ReceiveKeywordsGetPublicReceiveKeywordsWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfPublicReceiveKeywordsWithPaginationDto>> {
    return receiveKeywordsGetPublicReceiveKeywordsWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * For each user get Public ReceiveKeywords with paging.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiveKeywordsGetPublicReceiveKeywordsWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiveKeywordsGetPublicReceiveKeywordsWithPagination(params: ReceiveKeywordsGetPublicReceiveKeywordsWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfPublicReceiveKeywordsWithPaginationDto> {
    return this.receiveKeywordsGetPublicReceiveKeywordsWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfPublicReceiveKeywordsWithPaginationDto>): CustomResultOfPaginatedListOfPublicReceiveKeywordsWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `receiveKeywordsGetReceiveKeywordById()` */
  static readonly ReceiveKeywordsGetReceiveKeywordByIdPath = '/ReceiveKeywords/GetReceiveKeywordById';

  /**
   * Get ReceiveKeyword by Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiveKeywordsGetReceiveKeywordById()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiveKeywordsGetReceiveKeywordById$Response(params?: ReceiveKeywordsGetReceiveKeywordById$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfReceiveKeywordDto>> {
    return receiveKeywordsGetReceiveKeywordById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get ReceiveKeyword by Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiveKeywordsGetReceiveKeywordById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiveKeywordsGetReceiveKeywordById(params?: ReceiveKeywordsGetReceiveKeywordById$Params, context?: HttpContext): Observable<CustomResultOfReceiveKeywordDto> {
    return this.receiveKeywordsGetReceiveKeywordById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfReceiveKeywordDto>): CustomResultOfReceiveKeywordDto => r.body)
    );
  }

  /** Path part for operation `receiveKeywordsGetUsedPublicNumbersWithPagination()` */
  static readonly ReceiveKeywordsGetUsedPublicNumbersWithPaginationPath = '/ReceiveKeywords/GetUsedPublicNumbersWithPagination';

  /**
   * Get List of Used Public Numbers.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiveKeywordsGetUsedPublicNumbersWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiveKeywordsGetUsedPublicNumbersWithPagination$Response(params: ReceiveKeywordsGetUsedPublicNumbersWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetUsedPublicNumbersWithPaginationDto>> {
    return receiveKeywordsGetUsedPublicNumbersWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get List of Used Public Numbers.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiveKeywordsGetUsedPublicNumbersWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiveKeywordsGetUsedPublicNumbersWithPagination(params: ReceiveKeywordsGetUsedPublicNumbersWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetUsedPublicNumbersWithPaginationDto> {
    return this.receiveKeywordsGetUsedPublicNumbersWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetUsedPublicNumbersWithPaginationDto>): CustomResultOfPaginatedListOfGetUsedPublicNumbersWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `receiveKeywordsGetPublicReceiveKeywordsList()` */
  static readonly ReceiveKeywordsGetPublicReceiveKeywordsListPath = '/ReceiveKeywords/GetPublicReceiveKeywordsList';

  /**
   * Get Public ReceiveKeywords List.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiveKeywordsGetPublicReceiveKeywordsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiveKeywordsGetPublicReceiveKeywordsList$Response(params?: ReceiveKeywordsGetPublicReceiveKeywordsList$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetPublicReceiveKeywordsListDto>> {
    return receiveKeywordsGetPublicReceiveKeywordsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Public ReceiveKeywords List.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiveKeywordsGetPublicReceiveKeywordsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiveKeywordsGetPublicReceiveKeywordsList(params?: ReceiveKeywordsGetPublicReceiveKeywordsList$Params, context?: HttpContext): Observable<CustomResultOfListOfGetPublicReceiveKeywordsListDto> {
    return this.receiveKeywordsGetPublicReceiveKeywordsList$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetPublicReceiveKeywordsListDto>): CustomResultOfListOfGetPublicReceiveKeywordsListDto => r.body)
    );
  }

  /** Path part for operation `receiveKeywordsCreatePrivateReceiveKeywordGet()` */
  static readonly ReceiveKeywordsCreatePrivateReceiveKeywordGetPath = '/ReceiveKeywords/CreatePrivateReceiveKeyword';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiveKeywordsCreatePrivateReceiveKeywordGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiveKeywordsCreatePrivateReceiveKeywordGet$Response(params?: ReceiveKeywordsCreatePrivateReceiveKeywordGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return receiveKeywordsCreatePrivateReceiveKeywordGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiveKeywordsCreatePrivateReceiveKeywordGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiveKeywordsCreatePrivateReceiveKeywordGet(params?: ReceiveKeywordsCreatePrivateReceiveKeywordGet$Params, context?: HttpContext): Observable<Blob> {
    return this.receiveKeywordsCreatePrivateReceiveKeywordGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `receiveKeywordsCreatePrivateReceiveKeywordPost()` */
  static readonly ReceiveKeywordsCreatePrivateReceiveKeywordPostPath = '/ReceiveKeywords/CreatePrivateReceiveKeyword';

  /**
   * Create Private ReceiveKeyword.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiveKeywordsCreatePrivateReceiveKeywordPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiveKeywordsCreatePrivateReceiveKeywordPost$Response(params: ReceiveKeywordsCreatePrivateReceiveKeywordPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return receiveKeywordsCreatePrivateReceiveKeywordPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Private ReceiveKeyword.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiveKeywordsCreatePrivateReceiveKeywordPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiveKeywordsCreatePrivateReceiveKeywordPost(params: ReceiveKeywordsCreatePrivateReceiveKeywordPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.receiveKeywordsCreatePrivateReceiveKeywordPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `receiveKeywordsCreatePublicReceiveKeywordGet()` */
  static readonly ReceiveKeywordsCreatePublicReceiveKeywordGetPath = '/ReceiveKeywords/CreatePublicReceiveKeyword';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiveKeywordsCreatePublicReceiveKeywordGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiveKeywordsCreatePublicReceiveKeywordGet$Response(params?: ReceiveKeywordsCreatePublicReceiveKeywordGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return receiveKeywordsCreatePublicReceiveKeywordGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiveKeywordsCreatePublicReceiveKeywordGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiveKeywordsCreatePublicReceiveKeywordGet(params?: ReceiveKeywordsCreatePublicReceiveKeywordGet$Params, context?: HttpContext): Observable<Blob> {
    return this.receiveKeywordsCreatePublicReceiveKeywordGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `receiveKeywordsCreatePublicReceiveKeywordPost()` */
  static readonly ReceiveKeywordsCreatePublicReceiveKeywordPostPath = '/ReceiveKeywords/CreatePublicReceiveKeyword';

  /**
   * Create Public ReceiveKeyword.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiveKeywordsCreatePublicReceiveKeywordPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiveKeywordsCreatePublicReceiveKeywordPost$Response(params: ReceiveKeywordsCreatePublicReceiveKeywordPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return receiveKeywordsCreatePublicReceiveKeywordPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Public ReceiveKeyword.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiveKeywordsCreatePublicReceiveKeywordPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiveKeywordsCreatePublicReceiveKeywordPost(params: ReceiveKeywordsCreatePublicReceiveKeywordPost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.receiveKeywordsCreatePublicReceiveKeywordPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `receiveKeywordsUpdatePrivateReceiveKeywordGet()` */
  static readonly ReceiveKeywordsUpdatePrivateReceiveKeywordGetPath = '/ReceiveKeywords/UpdatePrivateReceiveKeyword';

  /**
   * Get ReceiveKeyword by Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiveKeywordsUpdatePrivateReceiveKeywordGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiveKeywordsUpdatePrivateReceiveKeywordGet$Response(params?: ReceiveKeywordsUpdatePrivateReceiveKeywordGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfReceiveKeywordDto>> {
    return receiveKeywordsUpdatePrivateReceiveKeywordGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get ReceiveKeyword by Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiveKeywordsUpdatePrivateReceiveKeywordGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiveKeywordsUpdatePrivateReceiveKeywordGet(params?: ReceiveKeywordsUpdatePrivateReceiveKeywordGet$Params, context?: HttpContext): Observable<CustomResultOfReceiveKeywordDto> {
    return this.receiveKeywordsUpdatePrivateReceiveKeywordGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfReceiveKeywordDto>): CustomResultOfReceiveKeywordDto => r.body)
    );
  }

  /** Path part for operation `receiveKeywordsUpdatePrivateReceiveKeywordPut()` */
  static readonly ReceiveKeywordsUpdatePrivateReceiveKeywordPutPath = '/ReceiveKeywords/UpdatePrivateReceiveKeyword';

  /**
   * Update Private ReceiveKeyword.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiveKeywordsUpdatePrivateReceiveKeywordPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiveKeywordsUpdatePrivateReceiveKeywordPut$Response(params: ReceiveKeywordsUpdatePrivateReceiveKeywordPut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return receiveKeywordsUpdatePrivateReceiveKeywordPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Private ReceiveKeyword.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiveKeywordsUpdatePrivateReceiveKeywordPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiveKeywordsUpdatePrivateReceiveKeywordPut(params: ReceiveKeywordsUpdatePrivateReceiveKeywordPut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.receiveKeywordsUpdatePrivateReceiveKeywordPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `receiveKeywordsUpdatePublicReceiveKeywordsGet()` */
  static readonly ReceiveKeywordsUpdatePublicReceiveKeywordsGetPath = '/ReceiveKeywords/UpdatePublicReceiveKeywords';

  /**
   * Get List of Used Organizations for Public Numbers.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiveKeywordsUpdatePublicReceiveKeywordsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiveKeywordsUpdatePublicReceiveKeywordsGet$Response(params?: ReceiveKeywordsUpdatePublicReceiveKeywordsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetUsedOrganizationsForPublicNumbersListDto>> {
    return receiveKeywordsUpdatePublicReceiveKeywordsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get List of Used Organizations for Public Numbers.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiveKeywordsUpdatePublicReceiveKeywordsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiveKeywordsUpdatePublicReceiveKeywordsGet(params?: ReceiveKeywordsUpdatePublicReceiveKeywordsGet$Params, context?: HttpContext): Observable<CustomResultOfListOfGetUsedOrganizationsForPublicNumbersListDto> {
    return this.receiveKeywordsUpdatePublicReceiveKeywordsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetUsedOrganizationsForPublicNumbersListDto>): CustomResultOfListOfGetUsedOrganizationsForPublicNumbersListDto => r.body)
    );
  }

  /** Path part for operation `receiveKeywordsUpdatePublicReceiveKeywordsPut()` */
  static readonly ReceiveKeywordsUpdatePublicReceiveKeywordsPutPath = '/ReceiveKeywords/UpdatePublicReceiveKeywords';

  /**
   * Update Public Receive Keywords.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiveKeywordsUpdatePublicReceiveKeywordsPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiveKeywordsUpdatePublicReceiveKeywordsPut$Response(params: ReceiveKeywordsUpdatePublicReceiveKeywordsPut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return receiveKeywordsUpdatePublicReceiveKeywordsPut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Public Receive Keywords.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiveKeywordsUpdatePublicReceiveKeywordsPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiveKeywordsUpdatePublicReceiveKeywordsPut(params: ReceiveKeywordsUpdatePublicReceiveKeywordsPut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.receiveKeywordsUpdatePublicReceiveKeywordsPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `receiveKeywordsDelete()` */
  static readonly ReceiveKeywordsDeletePath = '/ReceiveKeywords/{id}';

  /**
   * Delete ReceiveKeyword.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiveKeywordsDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiveKeywordsDelete$Response(params: ReceiveKeywordsDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return receiveKeywordsDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete ReceiveKeyword.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiveKeywordsDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiveKeywordsDelete(params: ReceiveKeywordsDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.receiveKeywordsDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

}
